import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { SubjectForm } from '../../../../components'
import { modelUtils } from "@/utils";
let { WizContainer, WizReduxTemplate } = framework_tool;
let {
    WizSelect,
    WizModal,
    WizTreeSelectList,
} = component_tool;
let { checkStrLength, $$, Session, dateUtils } = utils_tool;
import moment from 'moment';
class QuestionCategorySelect extends WizContainer {

    componentName = 'QuestionCategorySelect';

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            stateSelects:props.selects,
            rowData: new Date().getTime(),
        }
        this.propsSelects = props.selects
    }

    /**
     * 初始化时根据record判断是新增还是编辑
     */
    _componentDidMount() {
        this.doActions([
            {
                path: `questionType/nodeList`,
                payload: {
                    key: `questionType@treeData`,
                    apiParams: { type: this.props.type,state:1 }
                }
            }
        ])
    }
    propsAndStateOnChange = {
        treeData: this._getDataOver.bind(this),
    }
    _getDataOver(nextProps, nextState) {
        if (nextProps.treeData.code == 1) {
            if (nextProps.treeData.data && (nextProps.treeData.data instanceof Array)) {
                nextProps.treeData.data.forEach(data => {
                    this.giveKey(data)
                });
            }
        }
        return true;
    }

    /**给数据加key */
    giveKey(data) {
        data.key = data.value;
        if (data.children && data.children instanceof Array) {
            data.children.forEach(children => {
                this.giveKey(children)
            })
        }
    }

    _treeSelectOnClick(value, valueRows) {
        this.setState({
            modalVisible: true,
            rowData: new Date().getTime(),
        });
    }
    _wizSelectOnSubmit(value) {
        this.setState({
            modalVisible: false,
        });
        this.props.form.setFieldsValue({
            classify: this.state.stateSelects.map(select=>select.key)
        });
        this.propsSelects = this.state.stateSelects
    }
    //select中的change事件
    _wizSelectOnChange(value,option) {
        let classify = value.map(select=>select.key)
        this.props.form.setFieldsValue({
            classify: classify
        });
        let stateSelects = value.map(key=>({key:key.key,title:key.label,label:key.label}))
        this.setState({
            stateSelects: stateSelects
        });
        this.propsSelects = stateSelects
    }
    _wizSelectOnCancel(value) {
        this.setState({
            modalVisible: false,
            stateSelects: this.propsSelects,
        });
    }
    _renderOptions(propsSelects) {
        if (propsSelects && propsSelects.length) {
            
            return propsSelects.map((row, i) => this._renderOption(row))
        }
        return null
    }
    _renderOption(row) {
        if (row) {
            return (
                <WizSelect.Option key={row['key'] } value={row['title']} title={row['title']}>
                    {row['title']}
                </WizSelect.Option>
            )
        }
    }
    

    _render() {

        const { modalVisible, rowData  } = this.state
        let defaultValue = this.propsSelects.map(select=> {return {key:select.key,label:select.title}} )
        let checkedKeys = this.propsSelects.map(select=>select.key)
        let listCheck = this.propsSelects
        let treeData = this.props.treeData.data;
        let selectKey = this.propsSelects.map(select=>select.title).join(",")
        return (
            <>
                <div onClick={() => this._treeSelectOnClick()}>
                    <WizSelect
                         key={'wizSelect_' + selectKey}
                        defaultValue={defaultValue}
                        labelInValue
                        mode={'multiple'}
                        open={false}
                        placeholder={'请选择题目分类'}
                        onChange={(value, option) => this._wizSelectOnChange(value, option)}
                    >
                    {this._renderOptions(this.propsSelects)}
                    </WizSelect>
                </div>

                <WizModal
                    visible={modalVisible}
                    title={'选择'}
                    width={1000}
                    onOk={e => this._wizSelectOnSubmit(e)}
                    onCancel={e => this._wizSelectOnCancel(e)}
                >
                    <div style={{ height: 600, width: 950 }}>
                    <WizTreeSelectList
                        treeProps={{checkStrictly:true}}
                        key={'WizTreeSelectList_' + rowData}
                        treeData={treeData}
                        checkedKeys={checkedKeys}
                        listCheck={listCheck}
                        //selectListProps={this.props.selects}
                        itemProps={{
                            icon: 'unordered-list',
                            title: '题目分类',
                            tips: '请勾选所属题目分类'
                        }}
                        onChange={(selects) => {
                            this.setState({
                                stateSelects: selects,
                            });
                        }}
                    />
                    </div>
                </WizModal>
            </>)
    }
}

const mapStateToProps = (state, ownProps) => {
    const { bankQuestion, questionType} = state;

    const treeData = modelUtils.getModelEntity(questionType, "questionType@treeData");
   const load = modelUtils.getLoadingState(state, "selects");
   
    return {
        treeData,
        ...load
    }
};

const options = { withRef: true };
export default connect(mapStateToProps,null, null, options)(QuestionCategorySelect);

